import { useIsMobile } from 'common/hooks';
import './styles.scss';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { useTranslation } from 'react-i18next';

export const MapLayout = ({
  currentFloor,
  onHover,
  hoveredAmenity,
  onClick,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { title, img, amenities } = currentFloor;

  return (
    <TransformWrapper wheel={{ step: 0.05 }}>
      <TransformComponent>
        <div className="map-layout">
          <img src={img} alt={title} className="map-content" />
          {amenities.map(({ id, coordinates, name, img }) => {
            const { x, y } = coordinates;
            return (
              <div
                className={`tooltip  ${hoveredAmenity === id ? 'active' : ''} ${
                  img ? 'with-image' : ''
                }`}
                onClick={() => onClick(id)}
                onMouseEnter={() => onHover(id)}
                onMouseLeave={() => onHover(null)}
                style={{
                  position: 'absolute',
                  left: `${x}%`,
                  top: `${y}%`,
                }}
              >
                <div className="tooltip-container">
                  <div className="tooltip-trigger">
                    <span>{id}</span>
                  </div>

                  {(!isMobile || !img) && (
                    <div className={`tooltip-content`}>
                      <p className="tooltip-name">{t(name)}</p>
                      {img && (
                        <div className="tooltip-img">
                          <img src={img} alt={name} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </TransformComponent>
    </TransformWrapper>
  );
};
